import { TableTab } from '../../../components/ListV2/components/tabs/tableTabs.types';
import LangEnum from '../../../lang/LangEnum';
import { Ability } from '../../users/ability.types';
import { StatusType, lostOrderStatuses } from '../order.types';

export enum OrderListTabName {
  SUGGESTED = 'SUGGESTED',
  OPEN = 'OPEN',
  ON_APPROVAL = 'ON_APPROVAL',
  APPROVED = 'APPROVED',
  LOST = 'LOST',
  ALL = 'ALL',
}

export interface OrderTab extends TableTab<OrderListTabName> {
  status?: StatusType[];
}

const orderListTabs: OrderTab[] = [
  {
    title: LangEnum.GLOBAL_MALE_ALL,
    name: OrderListTabName.ALL,
  },
  {
    title: LangEnum.GLOBAL_SUGGESTED,
    name: OrderListTabName.SUGGESTED,
    status: [StatusType.SUGGESTED],
  },
  {
    title: LangEnum.GLOBAL_OPEN_PLURAL,
    name: OrderListTabName.OPEN,
    status: [StatusType.DRAFT, StatusType.IN_REVISION],
  },
  {
    title: LangEnum.ORDER_STATUS_ON_APPROVAL,
    name: OrderListTabName.ON_APPROVAL,
    status: [StatusType.ON_APPROVAL],
  },
  {
    title: LangEnum.GLOBAL_APPROVED_PLURAL,
    name: OrderListTabName.APPROVED,
    status: [StatusType.APPROVED, StatusType.SENT],
  },
  {
    title: LangEnum.GLOBAL_LOST,
    name: OrderListTabName.LOST,
    status: lostOrderStatuses,
  },
];

export const getOrderStatusByTab = (selectedTab?: OrderListTabName) =>
  orderListTabs.find((tab) => tab.name === selectedTab)?.status || [];

const getOrderListTabs = (userAbility: Ability) => {
  const allowedStatus = userAbility.getConditions()?.orderStatus ?? [];
  return allowedStatus.length
    ? orderListTabs.filter(
        (tab) => !tab.status || allowedStatus.some((status) => tab.status?.includes(status)),
      )
    : orderListTabs;
};

export default getOrderListTabs;
